import axios from "axios";
import { OrderApi } from "../api"
import { DocumentItem } from "./DocumentItem.class";
import Helper from "../plugins/Helper/Helper";
import moment from "moment"
import Vue from "vue";

export class Order {
  constructor(data) {
    this.className = data.className
    this.objectId = data.objectId || data.id
    this.isVatInclusive = data.isVatInclusive || false
    this.project = data.project
    this.market = data.market
    this.runningNumber = data.runningNumber
    this.runningMonth = data.runningMonth
    this.runningYear = data.runningYear
    this.isSent = data.isSent
    this.isPaid = data.isPaid
    this.totalPaidValue = data.totalPaidValue || 0
    this.areaInterest = data.areaInterest
    this.documentId = data.documentId || '-'
    this.documentType = data.documentType
    this.companyData = data.companyData || {}
    this.customerData = data.customerData || {}
    this.date = data.date && data.date.iso ? data.date.iso : null
    this.dueDate = data.dueDate && data.dueDate.iso ? data.dueDate.iso : null
    this.note = data.note || ""
    this.contract = data.contract
    this.booking = data.booking
    this.vatPercent = data.vatPercent || Vue.prototype.$globalVatPercent || 7
    this.isVat = data.isVat
    this.createdBy = data.createdBy || null
    this.updatedByText = data.updatedBy ? `${data.updatedBy.firstName} ${data.updatedBy.lastName}` : ''
    this.updatedAtText = data.updatedAt ? moment(data.updatedAt).format('DD MMM YYYY, HH:mm') : ''
    this.invoicePayment = data.invoicePayment
    this.receipts = data.receipts
    this.meter = data.meter
    this.isSuccess = data.isSuccess
    this.successAt = data.successAt
    this.lastUpdateSuccessAt = data.lastUpdateSuccessAt
    this.updateSuccessCount = data.updateSuccessCount
    this.isPaymentApprove = data.isPaymentApprove
    this.currencyCode = data.currencyCode || Vue.prototype.$globalCurrencyCode || "THB"
    this.items = [];
    if (data.items && data.items.length) {
      for (let item of data.items) {
        this.items.push(
          new DocumentItem(
            item,
            data.isVatInclusive,
            this.vatPercent,
          )
        );
      }
    } else {
      this.items.push(
        new DocumentItem(
          {},
          this.isVatInclusive,
          this.vatPercent,
        )
      );
    }

    if(data.booking) {
      this.businessName = this.booking.businessName ? this.booking.businessName : '-'
    } 
    
    if(data.contract){
      this.businessName = data.contract.businessName ? data.contract.businessName : '-'
    }
  }

  

  static async getOrder(id) {
    const { data } = await OrderApi.getOrder(id);
    return new Order(data.result)
  }
  static async getOrderByMeter(meterId) {
    const { data } = await OrderApi.getOrderByMeter(meterId);
    return data.result
  }
  static async getOrderBetweenDateByMeter(payload) {
    const { data } = await OrderApi.getOrderBetweenDateByMeter(payload);
    return data.result
  }
  static async getLastOrderByMeter(meterId) {
    const { data } = await OrderApi.getLastOrderByMeter(meterId);
    return data.result
  }
  static async getLastOrderByContract(contractId) {
    const { data } = await OrderApi.getLastOrderByContract(contractId);
    return data.result
  }
  static async createOrder(formData) {
    const { data } = await OrderApi.createOrder(formData);
    return data.result
  }
  static async cancelOrderInvoicePayment(id) {
    const { data } = await OrderApi.cancelOrderInvoicePayment(id);
    return data.result
  }
  static async sendOrder(formData) {
    const { data } = await OrderApi.sendOrder(formData);
    return data.result
  }
  static async getOrderUnPaidCoutByMeter(meterId) {
    const { data } = await OrderApi.getOrderUnPaidCoutByMeter(meterId);
    return data.result
  }

  get totalOriginalValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalOriginalValue || 0), 0)
    );
  }

  get totalVatValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalVatValue || 0), 0)
    );
  }

  get totalValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalValue || 0), 0)
    );
  }

  get totalNonVatValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
    );
  }

  get totalVatItemsValue() {
    return Helper.round(
      this.items
        .filter(d => {
          return d.sellVatType == 1;
        })
        .reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
    );
  }

  get totalNonVatItemsValue() {
    return Helper.round(
      this.items
        .filter(d => {
          return d.sellVatType != 1;
        })
        .reduce((a, b) => a + (b.totalNonVatValue || 0), 0)
    );
  }

  get totalWhtValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalWhtValue || 0), 0)
    );
  }

  get totalUnpaidValue() {
    if (this.isSent) return Helper.round(this.totalValue - this.totalPaidValue);
    else return 0;
  }

  get createdByFullName() {
    if (this.createdBy)
      return `${this.createdBy.firstName || ""} ${this.createdBy.lastName || ""}`;
    else
      return "";
  }

  get totalDiscountValue() {
    return Helper.round(
      this.items.reduce((a, b) => a + (b.totalDiscountValue || 0), 0)
    );
  }

  // get statusPrepare(){
  //   if(this.isPaid){
  //     return this.status = 'เสร็จสิ้น'
  //   }else if(!this.isPaid && !this.receipts && !this.isPaymentApprove){
  //      return this.status = 'ค้างชำระ'
  //   }else if(!this.isPaid && this.receipts){
  //      return this.status = 'ยกเลิก'
  //   }else if(!this.isPaid && !this.receipts && this.isPaymentApprove){
  //     return this.status = 'รอยืนยัน'
  //   }
  // }
}